import React from 'react';
import { NewsSection } from './news-section';
import { useListingSearch } from './use-listing-search';
import { useBTRNews } from './use-btr-news';
import { BtrResetBox } from '../btr-reset-box';
import { ListingsList } from './listings-list';
import { BTR_MORE_RESULTS_MAX_ADDITIONAL_LISTINGS } from './btr-more-config';
import { jsx as ___EmotionJSX } from "@emotion/core";
var BtrMoreResults = _ref => {
  var initNewsArticles = _ref.newsArticles,
    initSearchResults = _ref.searchResults,
    initTotalHits = _ref.totalHits,
    onAddToWatchlist = _ref.onAddToWatchlist,
    onClearBtr = _ref.onClearBtr,
    onExpandedBtrSearch = _ref.onExpandedBtrSearch,
    primarySearchResult = _ref.primarySearchResult,
    buildSearchApi = _ref.buildSearchApi,
    listingType = _ref.listingType,
    filters = _ref.filters,
    isExpandedSearch = _ref.isExpandedSearch;
  var _useBTRNews = useBTRNews(initNewsArticles, primarySearchResult),
    newsArticles = _useBTRNews.newsArticles,
    hasMoreArticles = _useBTRNews.hasMoreArticles;
  var _useListingSearch = useListingSearch(initSearchResults, initTotalHits, primarySearchResult, buildSearchApi, listingType, filters, isExpandedSearch),
    searchResults = _useListingSearch.searchResults,
    totalHits = _useListingSearch.totalHits;
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ListingsList, {
    searchResults: searchResults,
    onAddToWatchlist: onAddToWatchlist,
    totalHits: totalHits,
    primarySearchResult: primarySearchResult,
    onViewAll: onExpandedBtrSearch,
    isBTRExclusiveResult: true
  }), ___EmotionJSX(NewsSection, {
    articles: newsArticles,
    showCta: hasMoreArticles
  }), totalHits <= BTR_MORE_RESULTS_MAX_ADDITIONAL_LISTINGS && ___EmotionJSX(BtrResetBox, {
    listingType: listingType,
    buildSearchApi: buildSearchApi,
    onResetFiltersClick: onClearBtr,
    totalHits: primarySearchResult.totalHits,
    filters: filters
  }));
};
export { BtrMoreResults };